module.exports = {
      id: "follow-gnreach-usage",
      viewBox: "0 0 131 42",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#follow-gnreach",
      toString: function () {
        return this.url;
      }
    }